import { jsxs as c, jsx as o, Fragment as S } from "react/jsx-runtime";
import { QUERIES as e } from "@fcamna/shared-component-foundations";
import * as P from "react";
import M from "styled-components";
import { u } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { fordProIcons as v } from "@fcamna/shared-icons";
const { Checkmark: f, CancelClose: x, Edit: y } = v, b = ({
  children: r,
  _stepIndex: a,
  completed: t = !1,
  error: p = !1,
  className: C = "",
  activeIndex: i,
  markerText: k = "",
  label: T,
  _onStepChange: g,
  onClick: m
}) => {
  const l = (n) => {
    t && g && g(n);
  }, s = !!g, $ = a > i;
  return /* @__PURE__ */ c(
    "li",
    {
      className: `progress-step ${p ? t ? "is-error completed" : "is-error" : t ? "is-complete" : ""}
      ${a === i ? "is-active" : ""}
      
        ${C}`,
      children: [
        /* @__PURE__ */ c("div", { className: "progress-marker", children: [
          s ? /* @__PURE__ */ c(
            "button",
            {
              tabIndex: $ ? -1 : 0,
              onClick: () => l(a),
              className: `indicator ${t ? "" : "text"} edit-mode`,
              "aria-label": T,
              children: [
                t ? p ? /* @__PURE__ */ o(x, { size: "m" }) : /* @__PURE__ */ o(f, { size: "m" }) : k.substring(0, 2),
                t && /* @__PURE__ */ o(y, { size: "m" })
              ]
            }
          ) : /* @__PURE__ */ o("span", { className: `indicator ${t ? "" : "text"}`, onClick: m, children: t ? p ? /* @__PURE__ */ o(x, { size: "m" }) : /* @__PURE__ */ o(f, { size: "m" }) : k.substring(0, 2) }),
          /* @__PURE__ */ o("span", { className: "connector" })
        ] }),
        /* @__PURE__ */ o("div", { className: "progress-text", children: /* @__PURE__ */ o("h4", { className: "progress-title", children: T }) })
      ]
    }
  );
}, z = ["10px", "50px", "18px", "8px"], A = M.div`
  display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.display};
  flex-direction: ${(r) => r.$orientation === "horizontal" ? r.theme.components.progressTracker.ProgressTrackerContainer.flexDirection.orientation.horizontal : r.theme.components.progressTracker.ProgressTrackerContainer.flexDirection.orientation.default};
  @media ${e.laptopAndUp} {
    flex-direction: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.laptopAndUp.flexDirection};
  }

  .progress-tracker {
    display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.display};
    margin: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.margin};
    padding: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.padding};
    list-style: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.listStyle};
    width: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.width};

    @media ${e.laptopAndUp} {
      margin: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.laptopAndUp.margin};
    }

    &.vertical {
      width: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.width};
      margin: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.margin};
      height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.height};
      flex-direction: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.flexDirection};

      @media ${e.laptopAndUp} {
        margin: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.laptopAndUp.margin};
      }
      .progress-step {
        display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressStep.display};
        flex: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressStep.flex};
        min-height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressStep.minHeight};
      }
      .progress-marker .connector {
        right: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressMarker.connector.right};
        top: calc(
          ${(r) => r.theme.components.progressTracker.getSize("small")}} +
            ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressMarker.connector.top}
        );
        left: calc(${(r) => r.theme.components.progressTracker.getSize("small")} / 2);
        width: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressMarker.connector.width};
        margin: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressMarker.connector.margin};
        height: calc(
          100% - ${(r) => r.theme.components.progressTracker.getSize("small")} -
            ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressMarker.connector.height}
        );
        border-radius: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressMarker.connector.borderRadius};
        @media ${e.laptopAndUp} {
          top: calc(
            ${(r) => r.theme.components.progressTracker.getSize("large")} +
              ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.vertical.progressMarker.connector.laptopAndUp.top}
          );
          left: calc(${(r) => r.theme.components.progressTracker.getSize("large")} / 2);
          height: calc(100% - ${(r) => r.theme.components.progressTracker.getSize("large")} - ${z[0]});
        }
      }
      .progress-text {
        padding: 0 ${(r) => r.theme.components.progressTracker.getSize("small")}
          calc(${(r) => r.theme.components.progressTracker.getSize("small")} / 2)
          ${(r) => r.theme.components.progressTracker.getSize("small")};
        @media ${e.laptopAndUp} {
          padding: 0 ${(r) => r.theme.components.progressTracker.getSize("large")}
            calc(${(r) => r.theme.components.progressTracker.getSize("large")} / 2)
            ${(r) => r.theme.components.progressTracker.getSize("large")};
        }
      }
    }

    &.text-top {
      .progress-text {
        height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.textTop.progressText.height};
      }
      .progress-marker {
        top: -${(r) => r.theme.components.progressTracker.getSize("small")};
        @media ${e.laptopAndUp} {
          top: -${(r) => r.theme.components.progressTracker.getSize("large")};
        }
      }
    }

    &.disabled {
      cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.disabled.cursor};
      filter: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.disabled.filter};
      opacity: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.disabled.opacity};
    }

    .progress-text {
      display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.display};
      padding: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.padding};
      overflow: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.overflow};
      text-overflow: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.textOverflow};

      .tracker-text {
        font-size: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.trackerText.fontSize};
        font-family: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.trackerText.fontFamily};
        font-style: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.trackerText.fontFamily};
        font-weight: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.trackerText.fontWeight};
        line-height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.trackerText.lineHeight};
        color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.trackerText.color};
      }
      @media ${e.laptopAndUp} {
        display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressText.laptopAndUp.display};
      }
    }

    .progress-title {
      margin-top: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressTitle.marginTop};
      margin-bottom: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressTitle.marginBottom};
      font-size: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressTitle.fontSize};
      font-family: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressTitle.fontFamily};
      font-style: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressTitle.fontSyle};
      font-weight: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressTitle.fontWeight};
      line-height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressTitle.lineHeight};
      color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressTitle.color};
    }

    .progress-link {
      display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressLink.display};
      position: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressLink.position};
    }

    .progress-step {
      flex: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.flex};
      margin: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.margin};
      padding: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.padding};
      min-width: ${(r) => r.theme.components.progressTracker.getSize("small")};
      @media ${e.laptopAndUp} {
        min-width: ${(r) => r.theme.components.progressTracker.getSize("large")};
      }

      &.pointer {
        cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.pointer.cursor};
      }

      &.disabled {
        cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.disabled.cursor};
        filter: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.disabled.filter};
        opacity: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.disabled.opacity};
      }

      &:last-child {
        .progress-marker {
          .connector {
            display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.lastChild.progressMarker.connector.display};
          }
        }
      }
      @media ${e.mobile} {
        &:last-child {
          flex-grow: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isTabletAndBelow.flexGrow};
        }
      }
      @media ${e.tablet} {
        &:last-child {
          flex-grow: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isTabletAndBelow.flexGrow};
        }
      }
      .progress-marker {
        .indicator {
          border: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.progressMarker.indicator.border};
          color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.progressMarker.indicator.color};
          background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.progressMarker.indicator.backgroundColor};
        }
        .connector {
          background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.progressMarker.connector.backgroundColor};
        }
      }

      .progress-text {
        text-align: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.progressText.textAlign};
      }

      &.is-active {
        .progress-marker {
          .indicator {
            border: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isActive.progressMarker.indicator.border};
            color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isActive.progressMarker.indicator.color};
            background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isActive.progressMarker.indicator.backgroundColor};
          }
          .connector {
            background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isActive.progressMarker.connector.backgroundColor};
          }
        }
        .progress-text {
          .progress-title {
            color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isActive.progressText.progressTitle.color};
          }
        }
      }

      &.is-error {
        .progress-marker {
          .indicator {
            border: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.progressMarker.indicator.border};
            color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.progressMarker.indicator.color};
            background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.progressMarker.indicator.backgroundColor};
          }
          .connector {
            background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.progressMarker.connector.backgroundColor};
          }
        }

        &.completed {
          .progress-marker .connector {
            background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.completed.progressMarker.connector.backgroundColor};
          }
          & .edit-mode {
            cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.editMode.cursor};
            padding: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.editMode.padding};
            svg: nth-child(1) {
              display: block;
            }
            svg: nth-child(2) {
              display: none;
            }
            &:hover {
              border: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isHover.indicator.border};
              color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isHover.indicator.color};
              background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isHover.indicator.backgroundColor};
              svg: nth-child(1) {
                display: none;
              }
              svg: nth-child(2) {
                display: block;
              }
            }
          }
        }

        .progress-text {
          .progress-title {
            color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.progressText.progressTitle.color};
          }
        }

        &.is-active {
          .progress-marker {
            .indicator {
              border: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.isActive.progressMarker.indicator.border};
              color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.isActive.progressMarker.indicator.color};
              background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isError.isActive.progressMarker.indicator.backgroundColor};
            }
          }
        }
      }

      &.is-complete {
        .progress-marker {
          .indicator {
            border: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.progressMarker.indicator.border};
            color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.progressMarker.indicator.color};
            background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.progressMarker.indicator.backgroundColor};
            svg:nth-child(2) {
              display: none;
            }
            &.edit-mode {
              cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.editMode.cursor};
              padding: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.editMode.padding};
              &:hover {
                border: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isHover.indicator.border};
                color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isHover.indicator.color};
                background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isHover.indicator.backgroundColor};
                svg: nth-child(1) {
                  display: none;
                }

                svg: nth-child(2) {
                  display: block;
                }
              }
            }
          }

          .connector {
            background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.progressMarker.connector.backgroundColor};
          }
        }
        .progress-text {
          .progress-title {
            color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.progressText.progressTitle.color};
          }
        }
        &.is-active {
          .progress-marker {
            .indicator {
              border: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isActive.progressMarker.indicator.border};
              color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isActive.progressMarker.indicator.color};
              background-color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressStep.isComplete.isActive.progressMarker.indicator.backgroundColor};
            }
          }
        }
      }
    }

    .progress-marker {
      display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.display};
      position: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.position};

      .indicator {
        font-size: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.fontSize};
        font-weight: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.fontWeight};
        font-family: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.fontFamily};
        line-height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.lineHeight};
        &:hover{
          cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.hover.cursor};
          }
        &.disabled{
          cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.disabled.cursor};
            filter: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.disabled.filter};
              opacity: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.disabled.opacity};
        }
        @media ${e.laptopAndUp} {
          font-size: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.laptopAndUp.fontSize};
          line-height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.laptopAndUp.lineHeight};
        }
        font-style: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.fontStyle};
        &.text {
          padding: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.text.padding};
        }
        box-sizing: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.boxSizing};
        display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.display};
        justify-content: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.justifyContent};
        align-items: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.alignItems};
        position: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.position};
        z-index: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.zIndex};
        width: ${(r) => r.theme.components.progressTracker.getSize("small")};
        height: ${(r) => r.theme.components.progressTracker.getSize("small")};
        margin-left: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.marginLeft};
        margin-right: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.marginRight};
        border-radius: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.borderRadius};
        transition: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.transition};
        transition-duration: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.transitionDuration};
        @media ${e.laptopAndUp} {
          margin-left: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.laptopAndUp.marginLeft};
          width: ${(r) => r.theme.components.progressTracker.getSize("large")};
          height: ${(r) => r.theme.components.progressTracker.getSize("large")};
        }

        svg {
          margin: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.svg.margin};
          padding: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.svg.padding};
          width: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.svg.width};
          height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.svg.height};
          @media ${e.tabletAndUp} {
            width: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.svg.tabletAndUp.width};
            height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.indicator.svg.tabletAndUp.height};
          }
        }
      }
      .connector {
        content: '';
        display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.display};
        position: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.position};
        border-radius: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.borderRadius};
        z-index: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.zIndex};
        top: calc(${(r) => r.theme.components.progressTracker.getSize("small")} / 2);
        right: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.right};
        width: calc(
          100% - ${(r) => r.theme.components.progressTracker.getSize("small")} -
            ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.width}
        );
        height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.height};
        transition: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.transition};
        @media ${e.laptopAndUp} {
          right: calc(
            -50% + (
                ${(r) => r.theme.components.progressTracker.getSize("large")} +
                  ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.laptopAndUp.right}
              ) / 2
          );
          top: calc(${(r) => r.theme.components.progressTracker.getSize("large")} / 2);
          width: calc(
            100% - ${(r) => r.theme.components.progressTracker.getSize("large")} -
              ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.progressTracker.progressMarker.connector.laptopAndUp.width}
          );
        }
      }
    }
  }

  .stepContent {
    display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.display};
    .progress-text {
      display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.display};
      overflow: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.overflow};
      text-overflow: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.textOverflow};
      .tracker-text {
        font-size: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.trackerText.fontSize};
        font-family: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.trackerText.fontFamily};
        font-style: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.trackerText.fontSyle};
        font-weight: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.trackerText.fontWeight};
        line-height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.trackerText.lineHeight};
        color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.trackerText.color};
      }
      .progress-title {
        margin-top: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.progressTitle.marginTop};
        margin-bottom: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.progressTitle.marginBottom};
        font-size: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.progressTitle.fontSize};
        font-family: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.progressTitle.fontFamily};
        font-style: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.progressTitle.fontSyle};
        font-weight: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.progressTitle.fontWeight};
        line-height: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.progressTitle.lineHeight};
        color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.progressText.progressTitle.color};
      }
    }
    &.is-error {
      .progress-title {
        color: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.isError.progressTitle.color};
      }
    }
    &.is-disable {
      cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.isDisable.cursor};
      filter: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.isDisable.filter};
      opacity: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.isDisable.opacity};
    }
    &.pointer {
      cursor: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.pointer.cursor};
    }
    @media ${e.laptopAndUp} {
      display: ${(r) => r.theme.components.progressTracker.ProgressTrackerContainer.stepContent.laptopAndUp.display};
    }
  }
`, w = ({
  activeStep: r = 1,
  type: a = "simple",
  className: t = "",
  children: p,
  trackerVisible: C = !0,
  onStepChange: i
}) => {
  const k = u({ label: "Progress Tracker" }), T = !1, g = "horizontal";
  let m = null, l = 0, s = null;
  const $ = P.Children.map(p, (n, d) => {
    if (n && P.isValidElement(n) && n.type === b) {
      const h = n.props;
      return l++, r === d + 1 && (s = h), P.cloneElement(n, {
        _stepIndex: d + 1,
        activeIndex: r,
        completed: h.completed ? h.completed : d + 1 < r,
        // disabled: disabled || childEle.disabled,
        markerText: a === "progress" ? `${d + 1}` : h.markerText,
        _onStepChange: i
      });
    }
    return null;
  });
  return s && (m = /* @__PURE__ */ o(
    "div",
    {
      className: `stepContent
              ${s.error ? "is-error" : ""} 
              ${s.disabled ? "is-disable" : s.onClick ? "pointer" : ""}
              ${s.className ? s.className : ""}
            `,
      onClick: (n) => s.onClick && !T && !s.disabled && s.onClick(n),
      children: /* @__PURE__ */ c("div", { className: "progress-text", children: [
        /* @__PURE__ */ o("h4", { className: "progress-title", children: s.label }),
        C && /* @__PURE__ */ c(S, { children: [
          /* @__PURE__ */ o("span", { className: "tracker-text", children: `Step ${r} of ${l}` }),
          /* @__PURE__ */ o("br", {})
        ] }),
        s.children
      ] })
    }
  )), /* @__PURE__ */ c(
    A,
    {
      type: a,
      $orientation: g,
      ...k,
      children: [
        /* @__PURE__ */ o("ul", { className: `progress-tracker ${t}`, children: $ }),
        m
      ]
    }
  );
};
w.ProgressStep = b;
export {
  w as ProgressTracker
};
